module.exports = __webpack_public_path__ + "static/media/Industry-Light.dd6b7791.woff";